import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';

const normalizeRole = (role) => {
  if (!role) return '';
  const upper = role.toUpperCase();
  // Backend may emit role aliases that the route config doesn't list
  // directly; collapse them to the canonical persona used in the UI.
  if (upper === 'SUPER_ADMIN') return 'ADMIN';
  if (upper === 'WAREHOUSE_STAFF') return 'STAFF';
  return upper;
};

const ProtectedRoute = ({ children, allowedRoles }) => {
  const { isAuthenticated, user } = useSelector((state) => state.auth);
  const location = useLocation();

  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  if (allowedRoles && user?.role) {
    const userRole = normalizeRole(user.role);
    const allowed = allowedRoles.map((r) => r.toUpperCase());
    if (!allowed.includes(userRole)) {
      return <Navigate to="/dashboard" replace />;
    }
  }

  return children;
};

export default ProtectedRoute;
